<div class="inner-menu-container">
  @for (navItem of adminInnerItems; track navItem.route) {
    <mat-list-item
      [routerLink]="navItem.route"
      appAccordionLink
      routerLinkActive="active-link"
      (click)="onItemClick()"
    >
      <h4 class="side-nav-item">{{ navItem.name | translate | titlecase }}</h4>
    </mat-list-item>
  }
</div>
